

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.form = this.querySelector('form')
      if(this.form != null){

        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        
      }
      this.cartNotification = document.querySelector('cart-notification')
      // this.cartDrawer = document.querySelector('cart-drawer')
    }
    
    onSubmitHandler(evt) {
      //console.log('Form Submitted.')
      
      evt.preventDefault()
      const submitButton = this.querySelector('[type="submit"]')
      if (submitButton.classList.contains('loading')) return

      this.handleErrorMessage()
      this.cartNotification.setActiveElement(document.activeElement)

      submitButton.setAttribute('aria-disabled', true)
      submitButton.classList.add('loading')
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => {
        return(
          section.id
        )
      }))
      formData.append('sections_url', window.location.pathname)
      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description)
            return
          }
          updateCartG();
          $('#cart-icon-bubble').trigger('click');
          // this.cartNotification.renderContents(response)
          // console.log('Response: ',response)
          //renderSections(response.sections);
        })

        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          submitButton.classList.remove('loading')
          submitButton.removeAttribute('aria-disabled')
          $('.loading-overlay__spinner').addClass('hidden')
        })
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)
 
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    }

  })
}

function updateCartG() {
  fetch("/cart.js")
  .then(response => response.json())
  .then(data => {
    // console.log(data);
    $('body').find('#cart-icon-bubble span').text(data.item_count);
   
  })
  .catch(error => console.error("Error fetching cart:", error));
}

window.addEventListener('DOMContentLoaded', (event) => {
    // console.log('DOM fully loaded and parsed on PDP page==>');
    var getBackButtonHistory = localStorage.getItem('backButtonHistoryfromPDP');
    var getBrowserHistory = localStorage.getItem('backToSearchHistory')
    var getBrowserHistorybyDynamicSearch = localStorage.getItem('backToSearchHistorybyDynamicSearch')
    var getBrowserHistorybyVIN = localStorage.getItem('backToSearchHistorybyVIN')
    if(getBackButtonHistory != null){
      $(document).find('[data-back-to-search-history]').attr('href', getBackButtonHistory).show();
    }
    if(getBrowserHistory != null){
      $(document).find('[data-back-to-search-history]').attr('href', getBrowserHistory).show();
    }
    if(getBrowserHistorybyDynamicSearch != null){
        $(document).find('[data-back-to-search-history]').attr('href', getBrowserHistorybyDynamicSearch).show();
      }
    if(getBrowserHistorybyVIN != null){
        $(document).find('[data-back-to-search-history]').attr('href', getBrowserHistorybyVIN).show();
      }
});


